import { createFileRoute } from '@tanstack/react-router'
import { userQueryOptions } from '../../../features/admin/queries'
import { UserPage } from '../../../features/admin/user-pages'

export const Route = createFileRoute('/_app/users/$userId')({
  staticData: { crumb: 'user' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(userQueryOptions(params.userId)),
  component: UserPage,
})
